<script>
import appConfig from "@/app.config";

export default {
  page: {
    title: "Account Deactivated",
    meta: [{ name: "description", content: appConfig.description }]
  },
  methods: {
    logout() {
      this.$store.dispatch("oauth2/logout").then(() => {
        this.$router.push("/login");
      });
    },
  },
};
</script>
<template>
  <div class="account-pages my-5 pt-5">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="text-center mb-5">
            <h1 class="display-2 fw-medium">
              <i class="bx bx-user-x text-warning display-2"></i>
            </h1>
            <h4 class="text-uppercase">Account Deactivated</h4>
            <p class="text-muted">Your account has been deactivated. Please contact an administrator.</p>
            <div class="mt-5 text-center">
              <button class="btn btn-primary" @click="logout">Back to Login</button>
            </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/error-img.png" alt class="img-fluid" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
